import { Typography } from "@mui/material";
import React from "react";
import { Outlet } from "react-router-dom";

export default function YouthSignUp() {
  return <Outlet />;
}